type Mapper<T, R> = (item: T, index: number, array: T[]) => R | Promise<R>;

//

async function pMap<T, R, W = R, A extends unknown[] = unknown[]>(
  array: T[],
  mapper: Mapper<T, R>,
  wrapper?: (callback: () => R | Promise<R>, ...args: A) => W | Promise<W>,
  ...args: A
): Promise<W[]> {
  const _wrapper = wrapper ?? ((c: () => unknown) => c() as W | Promise<W>);
  const results: W[] = [];

  await Promise.all(
    array.map(async (item, index) => {
      const result = await _wrapper(() => mapper(item, index, array), ...args);
      results[index] = result;
    }),
  );

  return results;
}

//

export default pMap;
